<template>
    <div>
        <v-simple-table v-for="openingDiff in diff.diffs">
            <tr>
                <td v-if="openingDiff.old === null" width="45%">
                </td>
                <td v-else width="45%">
                    <small class="p-0">Ancien</small>
                    <vt-opening-diff-card :opening-diff="openingDiff" :is-new-period="false"
                                              :data="openingDiff.old"></vt-opening-diff-card>
                </td>

                <td v-if="openingDiff.new === null" width="45%">
                </td>
                <td v-else width="45%">
                    <small style="color:#FF9800" class="p-0">Nouveau</small>
                    <vt-opening-diff-card :opening-diff="openingDiff" :is-new-period="true"
                                              :data="openingDiff.new"></vt-opening-diff-card>
                </td>
            </tr>
        </v-simple-table>
    </div>
</template>

<script>

import VtOpeningDiffCard from "./cardDiffsComponents/VtOpeningDiffCard.vue"
import { mapState } from "vuex"

export default {
    name: "GoogleOpeningPeriodFieldDiffs",
    props: ["diff"],
    components: {
        VtOpeningDiffCard,
    },
}
</script>